import { css } from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

import WrapperContainer from 'components/Page/Wrapper/styled/WrapperContainer';

import { jumbotron as businessJumbotron } from '../../home/styles';

export const jumbotron = css`
  ${businessJumbotron} h1 {
    max-width: initial;
  }

  p {
    max-width: initial;
  }

  ${WrapperContainer} {
    min-height: 400px;

    > a > span {
      font-size: 1.3em;
      color: white;
      text-align: left;
      display: block;
      margin-top: 70px;
      margin-bottom: 8px;
      cursor: pointer;
      ${media.lessThan('sm')`
          margin-top: 24px;
       `};
    }
  }
`;
